module.exports = __webpack_public_path__ + "img/fitt_light_cropped.786e9107.png";